import {Platform} from 'react-native';
import {
    canUseFullScreenIntent,
    isIncomingCallNotificationAvailable,
    openFullScreenIntentSettings,
} from './incomingCallNotification';

/**
 * Android 14+ "full-screen calls" permission prompt (premium HappyAlert).
 *
 * Without USE_FULL_SCREEN_INTENT granted, an incoming VoIP call only shows a
 * heads-up notification and cannot take over the LOCKED screen. Shown once per
 * app session after SIP registration (and on demand from the VoIP settings).
 */

let promptedThisSession = false;

/**
 * Ask the user to allow full-screen calls when the OS reports it is denied.
 * @param {{force?: boolean}} [options] `force` ignores the once-per-session guard.
 * @returns {Promise<boolean>} Whether the settings screen was opened.
 */
export async function maybePromptFullScreenIntent({force = false} = {}) {
    if (Platform.OS !== 'android' || !isIncomingCallNotificationAvailable()) {
        return false;
    }
    if (promptedThisSession && !force) {
        return false;
    }
    if (await canUseFullScreenIntent()) {
        return false;
    }
    promptedThisSession = true;
    try {
        // eslint-disable-next-line global-require
        const i18n = require('../../i18n').default;
        // eslint-disable-next-line global-require
        const HappyAlert = require('../components/HappyAlert').default;
        const t = (key, fallback) => i18n.t(key, {defaultValue: fallback});
        const confirmed = await HappyAlert.confirm({
            type: 'info',
            title: t('voip_fsi_title', 'Teljes képernyős hívások'),
            message: t('voip_fsi_message', 'Engedélyezd a teljes képernyős hívásokat, hogy lezárt képernyőn is csörögjön.'),
            confirmText: t('voip_fsi_open_settings', 'Beállítások megnyitása'),
            cancelText: t('voip_fsi_later', 'Később'),
        });

        return confirmed ? openFullScreenIntentSettings() : false;
    } catch (_error) {
        return false;
    }
}

/** Test-only: reset the once-per-session guard. */
export function resetFullScreenIntentPrompt() {
    promptedThisSession = false;
}
